import { useNavigate } from 'react-router-dom';

type Options = { replace?: boolean; absolute?: boolean; state?: { from: string } };

export type NavigateFn = (to: string | number, options?: Options) => void;

export const useCustomNavigate = (): NavigateFn => {
    const navigate = useNavigate();

    return (to, options = {}) => {
        const isHostPath = `/${to}`;

        if (typeof to === 'number') {
            navigate(to);
        } else {
            if (options.absolute) {
                navigate(to, options);
            } else {
                navigate(isHostPath, options);
            }
        }
    };
};
